import { React, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from 'react-icons/fa';
import MarketMarquee from '../users/MarketMarquee';
import useInView from "../lib/useInView";
import investIMG from "../images/trade-girl.webp";
import '../styles/Hero.css';

const HeroSection = () => {
    const navigate = useNavigate();
    // word change animations
    const words = ["Stocks", "Investments", "e-Farming"];
    const [currentWordIndex, setCurrentWordIndex] = useState(0);

    // Cycle through words every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [words.length]);

    const [boxSavingRef, boxSavingInView] = useInView({ threshold: 0.5 });
    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });


    return (
        <>
            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text and Sub-Boxes */}
                    <div className="hero-text-container">
                        <h1 className="hero-title">
                            We Revolutionize  <span>{words[currentWordIndex]}</span>
                        </h1>
                        <p className="hero-description">
                            We've grown to become one of the largest digital stock providers, committed to inventing, simplifying, and humanizing the trading experience.
                        </p>
                        <h2 className="hero-description">
                            Turn your plans into <span className="circle-text">goals</span>
                        </h2>
                        <div
                            ref={boxSavingRef}
                            className={`sub-container animate__animated ${boxSavingInView ? "animate__flipInX" : ""}`}
                        >
                            <div className="sub-box">Stocks</div>
                            <div className="sub-box">Crypto</div>
                            <div className="sub-box">Investments</div>
                        </div>
                    </div>

                    {/* Right Box: Image */}
                    <div className="hero-image-container">
                        <img
                            src={investIMG}
                            alt="Hero"
                            ref={box1Ref}
                            className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
                        />
                    </div>
                </div>

                {/* Display Sliding Carousel */}
                <MarketMarquee />
            </div>
            <div className="hero-section-cover">
                <div className="overlaying-img"></div>
                <div className="cover-container">
                    <div className="left-side-box">
                        <h1>  Our power is in our ability to make great investments</h1>
                    </div>
                    <div className="right-side-box">
                        <p>
                            Since it’s formation in 2014, Diamond FXTL Trades has completed more than 2.5M transactions, representing well over USD 50 Billion, In transaction volume encompassing domestic and cross boarder asset sales, strategic advice, restructuring, and equity private placements.
                        </p>
                        <button
                            onClick={() => navigate("/login")}
                            className="delete-button cta-btn">
                            Get Started   <FaArrowRight />
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HeroSection;